import {StyleSheet} from 'react-native';

import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import color from './competency.color';

export const textColor = StyleSheet.create({
  [COACH]: {
    color: color[COACH].primary,
  },
  [BUSINESS_COACH]: {
    color: color[BUSINESS_COACH].primary,
  },
  [BUSINESS_LEADER]: {
    color: color[BUSINESS_LEADER].primaryLight,
  },
});
